// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shift-backdrop{position:absolute;z-index:24;left:0;top:0;width:100%;height:100%;background:transparent;cursor:pointer}", ""]);
// Exports
module.exports = exports;
